import {
  Tab,
  TabList,
  makeStyles,
  shorthands,
} from "@fluentui/react-components";
import React from "react";
import { useFormPageStore } from "store/FormPageStore";
import { MoneyHandRegular, MoneyHandFilled } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles({
  card: {
    ...shorthands.margin("auto"),
    width: "800px",
    maxWidth: "100%",
    marginTop: "20px",
    marginBottom: "100px",
    justifyContent: "center",
  },
  cardTab: {},
});
const InvoiceSidebar = () => {
  const [
    { invoiceTab, selectedProduct, progress, offerLoadStatus },
    { setFormStoreValue },
  ] = useFormPageStore();
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div
      style={{
        flexShrink: 0,
        width: "200px",
      }}
    >
      <TabList
        selectedValue={invoiceTab.selectedTab}
        className={classes.card}
        vertical={true}
        size="large"
      >
        {selectedProduct?.hasCasco ? (
          <Tab
            color="white"
            icon={<MoneyHandRegular />}
            value="tab1"
            className={classes.cardTab}
            disabled={
              invoiceTab.disabledTabs.includes("tab1") ||
              offerLoadStatus === "loading"
            }
            onClick={() =>
              setFormStoreValue("invoiceTab", {
                ...invoiceTab,
                selectedTab: "tab1",
              })
            }
          >
            {t("bcr.invoiceTab1CascoInvoice.label")}
          </Tab>
        ) : null}
        {selectedProduct?.hasMtpl ? (
          <Tab
            icon={<MoneyHandFilled />}
            value="tab2"
            disabled={
              invoiceTab.disabledTabs.includes("tab2") ||
              offerLoadStatus === "loading"
            }
            onClick={() =>
              setFormStoreValue("invoiceTab", {
                ...invoiceTab,
                selectedTab: "tab2",
              })
            }
          >
            {t("bcr.invoiceTab2MtplInvoice.label")}
          </Tab>
        ) : null}
      </TabList>
    </div>
  );
};

export default InvoiceSidebar;
